import { type IDataStoreRecordBehaviors } from '../../../collaboration/DataStoreRecordBehaviors';
import type BaseField from '../../../fields/BaseField';
import EditSelectInput from './SelectFieldInput';
import EditTextInput from './TextFieldInput';

export interface FieldInputProps {
  field: BaseField;
  objects: Array<fabric.Object & IDataStoreRecordBehaviors>;
  value: any;
  sameValue: boolean;
}

const FieldInputs: Record<string, React.FC<FieldInputProps>> = {
  SelectField: EditSelectInput,
  TextField: EditTextInput,
};

export default FieldInputs;
